import React from 'react';
import { TemplateForm } from '../../../components/forms/TemplateForm';

export default function TemplateCreatePage() {
  return <TemplateForm />;
}
